import styled from 'styled-components';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { SIZE } from 'common/sizes';
import { Label } from 'common/baseComponents';
import { LIST } from 'common/base';

export const MainGMBContainer = styled.div`
    display: flex;
    justify-content: center;
    padding: ${SIZE.FIVE}px 0;
`
export const GMBContainer = styled.div`
    display:flex;
    flex-flow: column;
    width: 100%;
`
export const BoxContainer = styled.div`
    padding: 49px 60px 20px 63px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: -2px 4px 15px 0 rgba(0, 0, 0, 0.15);
`

export const ContentGMBContainer = styled.div`
    display: flex;
    flex-flow: column;
    border-radius: 10px;
    border: solid 0px #c4c4c4;
    word-break: break-all;
`

export const ContentGMBContainerSection = styled.div`
    display: flex;
    flex-flow: column;
    padding: ${SIZE.ONE}px 0px ${SIZE.THREE}px 0px;
`

export const SidesPadding = styled.div`
    padding: 0px 22px 0px 22px;
`

export const Title = styled.div`
    display: flex;
    flex-flow: row;
    font-family: Rubik;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;    
    text-align: left;
    color: #525252;    
    margin-bottom: 22px;
`

export const Subtitle = styled.div`
    display: flex;
    flex-flow: row;
    font-family: Rubik;
    font-size: 20px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;    
    text-align: left;
    color: #525252;    
    margin-top: ${SIZE.THREE}px;
`

export const ListContainer = styled(LIST)`
    flex: 1;
    div {
        margin: ${SIZE.HALF}px ${SIZE.ONE}px ${SIZE.HALF}px 0;
    }
`

export const ViewLabel = styled.span`
    display: flex;
`

export const FieldSectionContainer = styled.div`
    display: flex;
    flex-flow: column;
    margin: ${SIZE.TWO}px ${SIZE.ONE}px;

`

export const FieldSectionContent = styled.div`
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    color: #000;
    margin: ${SIZE.ONE}px 0 0 0;
`

export const FieldSectionContainerTitle = styled(Label)`
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 16px;
    font-weight: bold;
    text-align: left;
    color: #525252;
`